module.exports = __webpack_public_path__ + "static/media/ACS SiteCon User Research Index.7562f0f1.csv";